let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2oC4k")).then(() => parcelRequire('7zD7u'));